export default __webpack_public_path__ + "media/images/ui-icons_777620_256x240-f423048bf942a7a33b33b1b982ecdb51.png";